var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"align-items-center d-flex md-button-loader",class:{
    'md-button-loader--active': _vm.isLoad,
    'md-button-loader--center': _vm.center
  }},[(_vm.icon.length > 0)?_c('md-icon',{class:_vm.iconClass},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"md-button-loader_spinner"},[_c('Spinner',{class:{ 'md-accent': _vm.accent },attrs:{"size":_vm.loaderSize}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }